import { Box,  IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from "react-router-dom";

export interface OrganizationMenuProps {
    organizationId: number;
    onClickEdit: () => void;
    onClickEditMailingPermit: () => void;
    onClickAddClient: () => void;
    onClickUpdateLogo: () => void;
    onClickShowProductForm: () => void;

}

export function OrganizationMenu(props: OrganizationMenuProps) {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const navigate = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };

      function handleClickEdit(){
        props.onClickEdit();
        handleClose();
      }

      function handleClickEditMailingPermit(){
        props.onClickEditMailingPermit();
        handleClose();
      }

        function handleClickAddClient(){
            props.onClickAddClient();
            handleClose();
        }

        function handleClickUpdateLogo(){
            props.onClickUpdateLogo();
            handleClose();
        }

        function handleShowProducts(){
          handleClose();
          navigate(`/organization/${props.organizationId}/products`);
      }

    return (
        <Box>

        <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClick}>
            <MoreVertIcon />
        </IconButton>

        <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            <MenuItem onClick={handleClickEdit}>Edit Organization</MenuItem>
                    <MenuItem onClick={handleClickEditMailingPermit}>Edit Mailing Permit</MenuItem>
                    <MenuItem onClick={handleClickAddClient}>Add Client</MenuItem>
                    <MenuItem onClick={handleClickUpdateLogo}>Update Logo</MenuItem>
                    <MenuItem onClick={handleShowProducts}>Products</MenuItem>
        </Menu>
        </Box>);

}